import { ICredentialService } from "../../service/credential/CredentialService";

export default class SaveLanguageToStorageInteractor {
  private credentialService: ICredentialService;

  constructor({
    credentialService
  }: {
    credentialService: ICredentialService;
  }) {
    this.credentialService = credentialService;
  }

  async execute(languageCode: string) {
    return this.credentialService.setLanguage(languageCode);
  }
}
